import { isConsoleHost } from "./consoleHost";

/**
 * Rotas da aplicação centralizadas.
 */

/** No console as páginas da plataforma ficam na raiz; no app, debaixo de /platform. */
const PLATFORM_BASE = isConsoleHost() ? "" : "/platform";
/** Centro de entregas e erros vivem no console, na raiz; no app os caminhos antigos redirecionam para lá. */
const ADMIN_BASE = isConsoleHost() ? "" : "/admin";

export const ROUTES = {
  home: "/",
  dashboard: "/dashboard",
  login: "/login",
  submit: "/submit",
  users: "/users",
  projects: "/projects",
  project: (id: string | number) => `/project/${id}`,
  financial: "/financial",
  documentExtractions: "/document-extractions",
  settings: "/settings",
  me: "/me",
  auth: {
    otp: "/auth/otp",
    resetPassword: "/auth/reset-password",
  },
  invitation: (token: string) => `/convite/${encodeURIComponent(token)}`,
  projectCosts: "/project-costs",
  projectDiary: "/project-diary",
  /** @deprecated Unificado em /settings?tab=access (Acessos & Permissões). A rota redireciona. */
  projectPermissions: "/project-permissions",
  /** @deprecated Unificado em /settings?tab=access (Acessos & Permissões). A rota redireciona. */
  projectRoles: "/project-roles",
  /** @deprecated Unificado em /settings?tab=access (Acessos & Permissões). A rota redireciona. */
  permissionsCatalog: "/permissions",
  roles: "/roles",
  stepPurchaseOrders: "/step-purchase-orders",
  systemProfiles: "/system-profiles",
  suppliers: "/suppliers",
  employees: "/employees",
  independentWorkers: "/independent-workers",
  collaborators: "/collaborators",
  tasks: "/tasks",
  crmChat: "/crm/chat",
  contacts: "/crm/contacts",
  adminSubmits: "/admin/submits",
  adminAppBuilds: "/admin/app-builds",
  adminAppHub: `${ADMIN_BASE}/entregas`,
  adminAppHubVersion: (app: string, environment: string, versionName: string) =>
    `${ADMIN_BASE}/entregas/${app.toLowerCase()}/versoes/${environment}/${encodeURIComponent(versionName)}`,
  deliveryCenter: `${ADMIN_BASE}/entregas`,
  deliveryArea: (product: string, area?: string) =>
    area ? `${ADMIN_BASE}/entregas/${product}/${area}` : `${ADMIN_BASE}/entregas/${product}`,
  adminAppDevice: `${ADMIN_BASE}/app-device`,
  adminWebQa: `${ADMIN_BASE}/entregas/web/testes`,
  adminAppReleases: "/admin/app-releases",
  appBuilds: "/admin/app-builds",
  adminErrors: `${ADMIN_BASE}/errors`,
  platformTenants: `${PLATFORM_BASE}/tenants`,
  platformTenantNew: `${PLATFORM_BASE}/tenants/new`,
  platformTenant: (id: string) => `${PLATFORM_BASE}/tenants/${encodeURIComponent(id)}`,
  platformReports: `${PLATFORM_BASE}/reports`,
  platformStorage: `${PLATFORM_BASE}/storage`,
  platformReportTemplates: `${PLATFORM_BASE}/reports/templates`,
  platformReportTemplate: (id: string) => `${PLATFORM_BASE}/reports/templates/${encodeURIComponent(id)}`,
  platformReportPlayground: `${PLATFORM_BASE}/reports/playground`,
  errors: `${ADMIN_BASE}/errors`,
  history: "/history",
  inventory: "/inventory",
  storages: "/inventory",
  storage: (id: string | number) => `/storage/${id}`,
  tickets: "/tickets",
  ticket: (id: string | number) => `/tickets/${id}`,

} as const;
